import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetReportJobQueueFilteredListInput } from './GetReportJobQueueFilteredListInput';
import { GetReportJobQueueFilteredListOutput } from './GetReportJobQueueFilteredListOutput';

export class GetReportJobQueueFilteredListService extends HttpServiceBase {

  handle = (input?: GetReportJobQueueFilteredListInput): Promise<Result<GetReportJobQueueFilteredListOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<GetReportJobQueueFilteredListOutput>>(`${this.baseUrlSislogApi}/v2/report-job-queue/filtered-list${parameters}`);
    return promise;
  }
}